import { useCallback, useState } from "react";
import { useDeviceType } from "@b2bportal/core-utilities";

import type { FlightLocationAutocompleteProps } from "./FlightLocationAutocomplete";
import type { FlightSuggestion } from "./types";

export const useFlightLocationAutocomplete = (
  props: FlightLocationAutocompleteProps
) => {
  const {
    id,
    value,
    label,
    onChange,
    onOpen,
    className,
    placeholder,
    defaultValue,
  } = props;
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  const { isDesktopAndUp } = useDeviceType();

  return {
    context: {
      id,
      defaultValue,
      value,
      label,
      className,
      placeholder,
      open,
      showLocationInput: isDesktopAndUp,
      useDialogOnMobile: !isDesktopAndUp,
    },
    handlers: {
      onChange: (val: FlightSuggestion) => {
        if (val != null) {
          onChange(val);
          closeDialog();
        }
      },
      onOpen,
      openDialog,
      closeDialog,
    },
  };
};
